/**
 * Frontend permission helpers - must match backend config/permissions.js
 */

export const ROLES = {
  ADMIN: 'admin',
  USER: 'user',
  VIEWER: 'viewer',
};

export const PAGE_PERMISSIONS = {
  Dashboard: [ROLES.ADMIN, ROLES.USER, ROLES.VIEWER],
  Apartments: [ROLES.ADMIN, ROLES.USER],
  Clients: [ROLES.ADMIN, ROLES.USER],
  ClientProfile: [ROLES.ADMIN, ROLES.USER],
  Contracts: [ROLES.ADMIN, ROLES.USER],
  SalesAndPayments: [ROLES.ADMIN, ROLES.USER],
  Reports: [ROLES.ADMIN, ROLES.USER],
  Home: [ROLES.ADMIN, ROLES.USER],
  Users: [ROLES.ADMIN],
};

export const ACTION_PERMISSIONS = {
  create: [ROLES.ADMIN, ROLES.USER],
  read: [ROLES.ADMIN, ROLES.USER, ROLES.VIEWER],
  update: [ROLES.ADMIN, ROLES.USER],
  delete: [ROLES.ADMIN, ROLES.USER],
  export: [ROLES.ADMIN, ROLES.USER],
  manageUsers: [ROLES.ADMIN],
  manageRoles: [ROLES.ADMIN],
};

export function canAccessPage(role, pageName) {
  const allowed = PAGE_PERMISSIONS[pageName];
  return allowed && allowed.includes(role);
}

export function canPerformAction(role, action) {
  const allowed = ACTION_PERMISSIONS[action];
  return allowed && allowed.includes(role);
}

export function isViewer(role) {
  return role === ROLES.VIEWER;
}
